export enum EnumQuestion {
    Nps = 1,
    FeedbackNps = 2,
    ShortText = 3,
    LikeDislike = 5,
    Stars = 6,
    SevenStars = 7,
    Checkboxes = 8,
    ScaleZeroToTen = 9,
    LongText = 10,
    RadioList = 11,
    Combobox = 12,
    OneFive = 13,
    SlideBar = 14,
    Smiles = 15,
    Button = 16,
    Info = 17,
    Matriz = 18
}